<div class="content">
    <div class="buttons" (click)="show = !show" @fadeOpacity *ngIf="show">
        <ng-content></ng-content>
    </div>
    <button-item (click)="show = !show" [opacity]="false" [back]="'white'" [icon]="'icon-toolbar-config'"></button-item>
</div>
